import { Pool } from "interfaces/pool";
import { Col, Container, Row } from "react-bootstrap";
import cardFlipStyles from "components/homepage-pools-list/card-flip.module.scss";
import HomepagePool from "./homepage-pool";
import { useState } from "react";
import { Entry } from "interfaces/entry";
import { Bet } from "interfaces/bet";
import SuccessfulBetModal from "components/pool-details/successful-bet-modal";
import { fetchBetsForContestEntry } from "state/slices/contests-slice.ts";
import { useAppDispatch } from "state/hooks.ts";

interface Props {
  pools: Pool[];
  isContestPool?: boolean;
  refetchPoolData: () => void;
  contestEntryId?: string;
}

const HomepagePoolsList = ({
  pools,
  isContestPool = false,
  refetchPoolData,
  contestEntryId,
}: Props) => {
  const dispatch = useAppDispatch();

  const [selectedEntry, setSelectedEntry] = useState<Entry>();
  const [selectedPool, setSelectedPool] = useState<Pool>();
  const [successfulBet, setSuccessfulBet] = useState<Bet | undefined>();

  const handleSuccessfulBet = (bet: Bet) => {
    setSelectedPool(undefined);
    setSelectedEntry(undefined);
    setSuccessfulBet(bet);
    if (contestEntryId) {
      dispatch(fetchBetsForContestEntry(contestEntryId));
    }
    refetchPoolData();
  };
  const handleCancel = () => {
    setSelectedEntry(undefined);
    setSelectedPool(undefined);
  };

  const handleSetSelectedEntry = (entry: Entry, pool: Pool) => {
    setTimeout(() => {
      setSelectedPool(pool);
      setSelectedEntry(entry);
    }, 500);
  };
  return (
    <>
      <Container fluid>
        <Row>
          {pools.map((pool, index) => {
            return (
              <Col
                key={pool.id + index}
                md={12}
                lg={6}
                xxl={4}
                className={cardFlipStyles.wrapper}
              >
                <HomepagePool
                  pool={pool}
                  contestEntryId={contestEntryId}
                  isContestPool={isContestPool}
                  handleSetSelectedEntry={handleSetSelectedEntry}
                  isSelected={pool === selectedPool}
                  selectedEntry={selectedEntry}
                  handleCancel={handleCancel}
                  setSuccessfulBet={handleSuccessfulBet}
                />
              </Col>
            );
          })}
        </Row>
      </Container>

      {successfulBet && (
        <SuccessfulBetModal
          bet={successfulBet}
          close={() => setSuccessfulBet(undefined)}
        />
      )}
    </>
  );
};

export default HomepagePoolsList;
